import { StatusInventoryView } from '@workspace/silk-ui';
import { useStatusInventoryController } from './useStatusInventoryController';

export default function StatusInventoryPage() {
  const viewModel = useStatusInventoryController();
  return <StatusInventoryView {...viewModel} />;
}
